module.exports = __webpack_public_path__ + "e18adb621250701a80b920a784481dfb.MP3";